import { Button, Col, Divider, Flex, Form, Input, Row, Upload } from "antd";
import EmpresaSelect from "../EmpresaSelect";
import Certificado from "../../../../../Models/Faturamento/Certificado";
import { UploadOutlined } from "@ant-design/icons";
import { useAdicionar } from "../../../../../Services/Pessoa/CertificadoService";
import { ReactElement } from "react";
interface ICertificadoFormCadastroProps {
    buttoCencelar?: ReactElement,
    onCancelar?: (evento: React.MouseEvent<HTMLElement, MouseEvent>) => void,
    onSalvarSucesso?: (codCertificado:number) => void
}
export default function CertificadoFormCadastro({
    buttoCencelar,
    onCancelar,
    onSalvarSucesso
}: ICertificadoFormCadastroProps) {
    const {
        mutate,
        isPending
    } = useAdicionar({
        onSuccess: onSalvarSucesso
    });

    return <Form<{
        certificado:Certificado,
        arquivo: File
    }>
        layout="vertical"
        autoComplete="off" 
        onFinish={mutate}
    >
        <Row gutter={8} wrap>
            <Col xs={12}>
                <Form.Item name={["certificado", "codPessoa"]} label={"Empresa"} >
                    <EmpresaSelect />
                </Form.Item>
            </Col>
            <Col xs={12}>
                <Form.Item name={["certificado", "senha"]} label={"Senha"} rules={[
                    {
                        required : true
                    }
                ]}>
                    <Input.Password placeholder="Senha" />
                </Form.Item>
            </Col>
            <Col 
                xs={24}
            >
                <Form.Item name={["arquivo"]} getValueFromEvent={({file}) => file}>
                    <Upload maxCount={1} beforeUpload={() => false} multiple={false}>
                        <Button icon={<UploadOutlined />}>Carregar arquivo</Button>
                    </Upload>
                </Form.Item>
            </Col>
            <Divider />
        </Row>
        <Flex gap="small" wrap="wrap" justify="center">
            {!!buttoCencelar && buttoCencelar}
            {
                !!!buttoCencelar && !!onCancelar && <Button type='primary' danger htmlType='reset' onClick={onCancelar}>
                    Cancelar
                </Button>
            }
            <Button type='primary' htmlType='submit' loading={isPending}>
                Salvar
            </Button>
        </Flex>
    </Form>
}